import HeroImage from '@/assets/Gemini_Generated_Image_nqric1nqric1nqri.jpeg';
import { scaleOnHover, slideInFromLeft, slideInFromRight, staggerContainer, viewportOptions } from '@/lib/animations';
import { Link } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { MotionButton } from '../ui/motion-button';

export default function Hero() {
  return (
    <div className="h-auto md:h-screen relative md:grid md:grid-cols-12 md:items-center">
      {/* Left content */}
      <motion.div
        className="md:col-span-6 md:pr-12 flex flex-col items-center md:items-start"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOptions}
      >
        <motion.h1
          className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-5 md:mb-5 text-center md:text-left"
          variants={slideInFromLeft}
        >
          Make <span className="text-brand">Waves</span> Selling Your Home
        </motion.h1>

        <motion.p
          className="text-xl md:text-2xl mb-8 leading-snug font-light text-center md:text-left"
          variants={slideInFromLeft}
        >
          Your complete home selling platform, powered by AI, with zero commission
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center md:justify-start gap-4"
          variants={slideInFromLeft}
        >
          <MotionButton
            className="bg-brand hover:bg-brand/90 px-6 py-4 h-auto font-medium text-lg"
            asChild
          >
            <Link to="/dashboard">
              Start Selling for Free
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </MotionButton>

          <MotionButton
            variant="outline"
            className="px-6 py-4 h-auto font-medium text-lg"
            asChild
          >
            <Link to="/properties">
              View Properties
            </Link>
          </MotionButton>
        </motion.div>
        <motion.div
          className="mt-12 md:mt-14 grid grid-cols-3 md:flex gap-4 md:gap-10 items-center justify-center md:justify-start"
          variants={slideInFromLeft}
        >
          <div className="space-y-1 text-center md:text-left">
            <p className="text-2xl md:text-2xl font-bold text-brand">$19K+</p>
            <p className="text-xs uppercase tracking-wide">Average Savings</p>
          </div>
          <div className="hidden md:block h-10 w-px bg-gray-200"></div>
          <div className="space-y-1 text-center md:text-left">
            <p className="text-2xl md:text-2xl font-bold text-brand">5.6x</p>
            <p className="text-xs uppercase tracking-wide">More Showings</p>
          </div>
          <div className="hidden md:block h-10 w-px bg-gray-200"></div>
          <div className="space-y-1 text-center md:text-left">
            <p className="text-2xl md:text-2xl font-bold text-brand">14d</p>
            <p className="text-xs uppercase tracking-wide">Avg. Time to Sell</p>
          </div>
        </motion.div>
      </motion.div>

      {/* Right image container */}
      <motion.div
        className="mt-14 md:mt-0 md:col-span-6 relative h-[400px] md:h-[calc(100vh-10rem)] md:mb-16"
        variants={slideInFromRight}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOptions}
      >
        <div className="absolute -inset-5 blur-xl bg-brand-lighter opacity-60 rounded-full"></div>
        <motion.div
          className="absolute inset-0 rounded-2xl overflow-hidden"
          variants={scaleOnHover}
          initial="rest"
          whileHover="hover"
        >
          <img
            src={HeroImage}
            alt="Modern home"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </motion.div>
      </motion.div>
    </div>
  );
}